<template>
  <div class="banner">
    <div class="banner__image">
      <img :src="content.image.url" :alt="content.image.alt">
    </div>
    <div class="banner__text">
      <ContentText :content="content.text" />
    </div>
  </div>
</template>

<script>
import ContentText from '@blocks/ContentText'

export default {
  name: 'TheBanner',
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  components: {
    ContentText
  }
}
</script>

<style lang="scss">
  .banner{
    @include media("small"){
      width: 100%;
      flex-direction: column-reverse;
      padding-top: layout("spacing");
    }
    @include media("medium"){
      width: 18rem;
      flex-direction: column;
    }
    @include media("large"){
      width: 20rem;
      flex-direction: column;
    }

    display: flex;
    justify-content: center;
    align-items: center;
    background-color: colors("background");

    // Image

    &__image{
      @include media("small"){
        width: 80%;
      }

      img{
        width: 100%;
      }
    }

    // Text

    &__text{
      @include media("small-medium"){
        padding-bottom: layout("spacing")*2;
      }

      padding: layout("spacing")/2;
      text-align: center;

      h2{
        @include media("small"){
          font-size: 2rem;
        }
        @include media("medium-large"){
          font-size: 1.6rem;
        }

        text-align: center;
        padding-bottom: layout("spacing")/3;
        margin-bottom: 1rem;
      }

      p, a{
        @include media("small"){
          font-size: 1.6rem;
        }
        @include media("medium-large"){
          font-size: 1.3rem;
        }

        color: white;
      }

      p{
        text-align: center;
        &:last-of-type{
          margin: 0;
        }
      }
    }
  }
</style>
